import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/app/shipments/$shipmentId")({
  component: () => <Outlet />,
});